import React, { useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useNotify } from "react-admin";
import axios from "axios";
import { envSettings } from "../settings/env";

const MONTHS = [
	{ value: 1, label: "January" },
	{ value: 2, label: "February" },
	{ value: 3, label: "March" },
	{ value: 4, label: "April" },
	{ value: 5, label: "May" },
	{ value: 6, label: "June" },
	{ value: 7, label: "July" },
	{ value: 8, label: "August" },
	{ value: 9, label: "September" },
	{ value: 10, label: "October" },
	{ value: 11, label: "November" },
	{ value: 12, label: "December" },
];

const YEARS = Array.from({ length: 10 }, (_, i) => 2026 + i);

const useStyles = makeStyles((theme) => ({
	root: { padding: theme.spacing(3) },
	title: { marginBottom: theme.spacing(3) },
	controls: {
		display: "flex",
		gap: theme.spacing(2),
		alignItems: "flex-end",
		marginBottom: theme.spacing(3),
		flexWrap: "wrap",
	},
	formControl: { minWidth: 160 },
	spinner: { marginLeft: theme.spacing(1) },
}));

export const KpiReport = () => {
	const classes = useStyles();
	const notify = useNotify();

	const now = new Date();
	const defaultMonth = now.getMonth() === 0 ? 12 : now.getMonth();
	const defaultYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();

	const [year, setYear] = useState(defaultYear);
	const [month, setMonth] = useState(defaultMonth);
	const [loading, setLoading] = useState(false);

	const handleDownload = async () => {
		setLoading(true);
		try {
			const res = await axios.get(`${envSettings.baseUrl}/kpi/snapshot/download`, {
				params: { year, month },
				withCredentials: true,
				responseType: "blob",
			});

			const monthLabel = MONTHS.find((m) => m.value === month)?.label || month;
			const filename = `kpi_report_${monthLabel}_${year}.csv`;
			const url = URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
			const a = document.createElement("a");
			a.href = url;
			a.download = filename;
			a.click();
			URL.revokeObjectURL(url);
		} catch (e) {
			const text = await e?.response?.data?.text?.();
			let message = "No snapshot found for the selected period.";
			try {
				const parsed = JSON.parse(text);
				message = parsed?.message || message;
			} catch {}
			notify(message, "error");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Card>
			<CardContent className={classes.root}>
				<Typography variant="h5" className={classes.title}>
					KPI Monthly Report
				</Typography>
				<div className={classes.controls}>
					<FormControl className={classes.formControl}>
						<InputLabel>Year</InputLabel>
						<Select value={year} onChange={(e) => setYear(e.target.value)}>
							{YEARS.map((y) => (
								<MenuItem key={y} value={y}>{y}</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl className={classes.formControl}>
						<InputLabel>Month</InputLabel>
						<Select value={month} onChange={(e) => setMonth(e.target.value)}>
							{MONTHS.map((m) => (
								<MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
							))}
						</Select>
					</FormControl>
					<Button
						variant="contained"
						color="primary"
						onClick={handleDownload}
						disabled={loading}
					>
						Download CSV
						{loading && <CircularProgress size={16} className={classes.spinner} />}
					</Button>
				</div>
			</CardContent>
		</Card>
	);
};
